import * as yup from 'yup';

const productInventorySchema = yup.object().shape({
  accountingCode: yup.string().required('common.required'),
  lowSeasonPrice: yup.string().required('common.required'),
  mediumSeasonPrice: yup.string().required('common.required'),
  highSeasonPrice: yup.string().required('common.required'),
  taxRate: yup.string().required('common.required'),
});

export default productInventorySchema;
